/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import loadingConfig from "./config/loading.config.json";
import { IssueCredentialProps, CredentialPreviewProps } from "./components";
import { getAgent } from "./agent";
const is = require("is_js");

const SERVICE_NAME = "IssueNewSelfAttestedCredentialPageService";
const log: any = LoggerModule.getInstance();

interface FormValueProps {
  [key: string]: any;
}

interface SelectedUsersProps {
  label: string;
  value: string;
}

interface UserDataProps {
  [key: string]: any;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class IssueNewSelfAttestedCredentialPageService {
  private static instance: IssueNewSelfAttestedCredentialPageService;
  private vapp: VApplication;
  private formData: any;
  private userData: any;
  private evidence: any;
  private credentialFillForm: any = {};
  private initialData: any = {};
  private allUsers: any = [];
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(
    props: any = {}
  ): IssueNewSelfAttestedCredentialPageService {
    if (!IssueNewSelfAttestedCredentialPageService.instance) {
      IssueNewSelfAttestedCredentialPageService.instance =
        new IssueNewSelfAttestedCredentialPageService(props);
    }
    return IssueNewSelfAttestedCredentialPageService.instance;
  }

  private setUserData(userData: UserDataProps) {
    this.userData = userData;
  }

  private setFormData(formData: any) {
    this.formData = formData;
  }

  private setFormValues(formData: any) {
    this.initialData = formData;
  }

  private setEvidence(evidence: any) {
    this.evidence = evidence;
  }

  private setAllUsers(users: any) {
    this.allUsers = users?.holdersList?.ultUsers;
  }

  private getWalletRegistered(user: string) {
    console.log("userData", this.allUsers);
    let _isWalletRegistered = false;
    let _userData =
      Array.isArray(this.allUsers) &&
      this.allUsers?.find((item) => item?.email === user);
    if (_userData?.accountStatus === "WALLET_REGISTERED") {
      _isWalletRegistered = true;
    }
    return _isWalletRegistered;
  }

  private resetData() {
    this.formData = null;
    this.userData = null;
    this.evidence = null;
    this.initialData = {};
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    let initialProps: any = null;
    const agent = getAgent();

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Settings Props
    // compProps = await agent.getSettingsProps({});
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }

    //Get credential form Props
    compProps = await agent.getCredentialFormProps({});
    if (compProps) {
      content = { ...content, ...compProps };
      // this.credentialFillForm = compProps;
    }

    compProps = await agent.getHoldersListProps(args);
    if (compProps) {
      this.setAllUsers(compProps);
      content = { ...content, ...compProps };
      // this.holderList.users = compProps;
    }

    //UserLists Props
    // compProps = await agent.getUserListProps(args);
    // if (compProps) {
    //   content = { ...content, ...compProps };
    // }
    return content;
  }

  public async issueCredential(credData: IssueCredentialProps) {
    let _data = {
      ...credData,
      formData: this.formData,
      userSelected: this.userData,
      evidence: this.evidence,
    };
    const agent = getAgent();
    const res = agent.getIssueCredential(_data);
    if (res) {
      this.resetData();
      return res;
    }
  }

  public async formSubmit(args: FormValueProps) {
    console.log(`form data`, args);
    this.setFormValues(args?.formData);
    // this.initialData = { ...(args?.formData || {}) };
    let evidence: any = [];
    let _formData: any = [];

    Object.entries(args?.formData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        evidence.push(...value);
      } else {
        _formData.push({
          key,
          value,
        });
      }
    });
    this.setFormData(_formData);
    this.setEvidence(evidence);
    return args?.formData;
  }

  public getCredentialForm() {
    return {
      ...(this.credentialFillForm || {}),
      initialData: this.initialData,
    };
  }

  public getHolderList() {
    return this.userData;
  }

  public resetStepperData() {
    this.resetData();
  }

  public async getPreviewCred(args: UserDataProps) {
    console.log(`user Data`, args?.userData);
    this.setUserData(args?.userData);
    let _walletRegistered = this.getWalletRegistered(args?.userData);
    let _previewData = {
      formData: this.formData,
      evidence: this.evidence,
      initialData: this.initialData,
      isWalletRegistered: _walletRegistered,
      ...args,
    };
    const agent = getAgent();
    return agent.getCredentialPreview(_previewData);
  }

  public getHolders(args: any) {
    const agent = getAgent();
    return agent.getHoldersListProps(args);
  }
}
